export default "__VITE_ASSET__scfUltuG__"